import ApiUser from '@/api/User'

export const state = () => ({
  tierId: null,
  userTier: null,
  annualSpend: 0,
  discount: 0
})

export const getters = {
  getTierId: state => {
    return state.tierId
  },
  getAnnualSpend: state => {
    return state.annualSpend
  },
  getUserTierName: state => {
    return state.userTier
  },
  getTierDiscount: state => {
    return state.discount
  }
}

export const mutations = {
  setTierId(state, tierId) {
    state.tierId = tierId
  },
  setUserTier(state, tierName) {
    state.userTier = tierName
  },
  setAnnualSpend(state, amount) {
    state.annualSpend = parseFloat(amount)
  },
  setTierDiscount(state, discount) {
    state.discount = parseFloat(discount)
  }
}

export const actions = {
  setTierId({ commit }, tierId) {
    commit('setTierId', tierId)
  },
  setUserTier({ commit }, tierName) {
    commit('setUserTier', tierName)
  },
  setAnnualSpend({ commit }, amount) {
    commit('setAnnualSpend', amount)
  },
  setTierDiscount({ commit }, discount) {
    commit('setTierDiscount', discount)
  },
  async fetchDesignerTier({ dispatch }) {
    try {
      const response = await ApiUser.getDesignerTier(this.$axios)

      if (response.data && response.data.tier_name) {
        dispatch('setTierId', response.data.tier_id)
        dispatch('setUserTier', response.data.tier_name)
        dispatch('setAnnualSpend', response.data.annual_spend)
        dispatch('setTierDiscount', response.data.discount)
      }

      return response.data
    } catch (error) {
      console.error('Failed to fetch designer tier:', error)
      throw error
    }
  }
}